<template>
  <div class="book-management">
    <listNav></listNav>
    <div class="book-management-content">
      <SideBar></SideBar>
      <Management class="content-container"></Management>
    </div>
  </div>
</template>
<script>
import SideBar from '@components/sidebars/Default.vue'
import listNav from '@components/list/listNav.vue'
import Management from '@views/Management.vue'
import { isLogin } from '@/utils'
import compareVipRight from '@components/common/compareVipRight.js'

export default {
  name: 'List',
  mixins: [compareVipRight],
  components: {
    SideBar,
    Management,
    listNav
  },
  async mounted() {
    await isLogin()
    await this.getVipInfo()
  }
}
</script>
<style lang="scss">
.book-management {
  display: flex;
  padding-top: 8px;
  flex-direction: column;
  .book-management-content {
    display: flex;
  }
  .content-container {
    width: calc(100% - 225px);
  }
}
</style>
